module.exports = __webpack_public_path__ + "static/media/icon-begin.50df161a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mywk/icon-begin.png
// module id = 2076
// module chunks = 4